/**
 * @file Analytics related Utils.
 */

import { WebGalleryMixPanel } from '../containers/WebGalleryAnalyticsInitContainer';
import { AUTH_TYPE } from '../../../constants/auth';

/**
 * @enum {string} ANALYTIC_EVENTS
 *
 * This list of events, in big part, attempt to match those in the
 * native mobile applications in order to gather overall consumer data.
 */
export const ANALYTIC_EVENTS = {
  // When the user logins with PIN Code
  LOGIN_WITH_PIN_CODE: 'Login with PIN code',
  // When the user logins with email/password
  LOGIN_WITH_EMAIL_PASSWORD: 'Login with Email/Password',
  // When a user favorites a photo in Photo Browser.
  PHOTO_BROWSER_DID_FAVORITE_PHOTO: 'Photo Browser: Photo Favorited',
  // When a user unfavorites a photo in Photo Browser
  PHOTO_BROWSER_DID_UNFAVORITE_PHOTO: 'Photo Browser: Photo Unfavorited',
  // When a user taps on share in Photo Browser
  PHOTO_BROWSER_DID_TAP_POSTCARD_BUTTON:
    'Photo Browser: Postcard Button Tapped',
  // When a user taps on share on facebook in Photo Browser
  PHOTO_BROWSER_DID_TAP_SHARE_ON_FB:
    'Photo Browser: Share Photo on Facebook Tapped',
  // When a user taps on Prints in Photo Browser
  PHOTO_BROWSER_DID_TAP_PRINTS: 'Photo Browser: Prints Button Tapped',
  // When a photo download operation completes
  PHOTOS_DOWNLOADED: 'Photo Download: Complete',
  // When the user opens the photo browser
  PHOTO_BROWSER_DISPLAYED: 'Photo Browser: Displayed',
  // When a user adds a new shipping address
  USER_ADDRESS_ADDED: 'Shipping Address: Added',
  // When a user edits a shipping address
  USER_ADDRESS_EDITED: 'Shipping Address: Edit',
  // When a user increased the quantity of a cart item
  CART_DID_INCREASE_QUANTITY: 'Cart: Item Quantity Increased',
  // When a user decreased the quantity of a cart item
  CART_DID_DECREASE_QUANTITY: 'Cart: Item Quantity Decreased',
  // When a user removes an item from the cart
  CART_DID_REMOVE_ITEM: 'Cart: Item Removed',
  // When a user submits an order
  CART_DID_SUBMIT_ORDER: 'Cart: Order Submitted',
  // When a user creates a new postcard
  POST_CARD_CREATED: 'Postcard: New Postcard Created',
  // When someone clicks on the blog post link:
  HOME_DID_TAP_BLOG_BUTTON: 'Home: Blog Button Tapped',
  // When the collage button is clicked:
  BUY_COLLAGE_TAPPED: 'Available Prints: Buy Collage Tapped',
  // When the collage button is clicked in WebGalleryCollageUpsellMoadl
  COLLAGE_PITCH_VIEW_BUY_TAPPED: 'Camper Collage Pitch View: Buy Tapped',
  // When the collage upsell displays
  COLLAGE_PITCH_VIEW_SHOW: 'Camper Collage Pitch View: Shown',
  // When the collage is purchased:
  COLLAGE_CHECKOUT_SUCCESS: 'Collage Configurator: Collage Purchased',
};

const whitelist = [
  ANALYTIC_EVENTS.COLLAGE_PITCH_VIEW_SHOW,
  ANALYTIC_EVENTS.COLLAGE_PITCH_VIEW_BUY_TAPPED,
  ANALYTIC_EVENTS.COLLAGE_CHECKOUT_SUCCESS,
  ANALYTIC_EVENTS.BUY_COLLAGE_TAPPED,
];

/**
 * Tracks an event for Web Galleries.
 *
 * @param {ANALYTIC_EVENTS} eventType Type of the event to track.
 * @param {Object} opts List of options specific to the event tracking.
 */
export const trackWebGalleryEvent = (eventType, opts = {}) => {
  if (!whitelist.includes(eventType)) {
    return;
  }

  const values = Object.values(ANALYTIC_EVENTS);
  if (!eventType || !values.includes(eventType) || !WebGalleryMixPanel) {
    return;
  }

  WebGalleryMixPanel.track(eventType, {
    ...opts,
  });
};

export const trackAuthEvent = authType => {
  switch (authType) {
    case AUTH_TYPE.EMAIL:
      trackWebGalleryEvent(ANALYTIC_EVENTS.LOGIN_WITH_EMAIL_PASSWORD);
      break;
    case AUTH_TYPE.PHONE:
      trackWebGalleryEvent(ANALYTIC_EVENTS.LOGIN_WITH_PIN_CODE);
      break;
    default:
      break;
  }
};
